export const auth = {
  login: "Login",
  logout: "Are you sure you want to logout?",
  form: {
    password: {
      label: "Password",
      errors: {
        empty: "Please enter your password.",
      },
    },
    newPassword: {
      label: "New password",
      errors: {
        empty: "Please enter your new password.",
        min: "Password must be at least 8 characters long.",
        lowercaseLetter: "Password must contain at least one lowercase letter.",
        uppercaseLetter: "Password must contain at least one uppercase letter.",
        number: "Password must contain at least one number.",
        specialCharacter:
          "Password must contain at least one special character.",
      },
    },
    confirmPassword: {
      label: "Confirm new password",
      errors: {
        empty: "Please confirm your new password.",
        dontMatch: "The two passwords entered do not match.",
      },
    },
  },
};
